export const getVersion = () => import.meta.env.VITE_VERSION || 'dev';
